import { capitaliseFirstLetter } from '../lib/utils';

// TO DO: Add new product properties (Phase 2)
export const generateCheckoutItemsGA4 = products =>
  products.map(({ id, description, brand, category, goods, stepId }) => ({
    item_id: id,
    // part_code needs removing when value is added in phase 2
    // ...(partCode && { part_code: '001 BLACK' }),
    item_name: description,
    currency: 'GBP',
    // ...(discount && { discount: 0.5 }),
    index: 0, // Not product listing page so default to 0
    item_brand: brand,
    item_category: category,
    // ...(itemCategory2 && { item_category2: 'Enclosures' }),
    // ...(itemCateogry3 && { item_category3: 'PVC Enclosures' }),
    // ...(itemListId && { item_list_id: 'search_results' }),
    // ...(itemListName && { item_list_name: 'Search Results' }),
    // ...(affiliation && { affiliation: 'Online' }),
    // ...(itemVariant && { item_variant: 'Same Day Range' }),
    // ...(deliveryStock && { delivery_stock: 'In Stock' }),
    // ...(selectedStores && { selected_store: 'Durham' }),
    // ...(stockStock && { store_stock: 'Out of Stock' }),
    price: parseFloat(goods),
    // ...(dimension4 && { dimension4: '' }),
    // ...(dimension5 && { dimension5: '' }),
    // ...(dimension6 && { dimension6: '' }),
    quantity: 1,
    id_variant: stepId,
  }));

const createItemList = page => {
  if (page === 'Sticky Basket') {
    return {
      itemListId: page.split(' ').join('_').toLowerCase(),
      itemListName: page,
    };
  }

  if (typeof page !== 'string') {
    return {
      itemListId: 'n_a',
      itemListName: 'N/A',
    };
  }

  return {
    itemListId: `${capitaliseFirstLetter(page)}_page`.toLowerCase(),
    itemListName: `${capitaliseFirstLetter(page)} Page`,
  };
};

// TO DO: Add extra properties in Phase 2
export const generateListItemsGA4 = (page, products, prices, index) => {
  const { itemListId, itemListName } = createItemList(page);

  const productIndex = index ?? 0;

  return products.map(
    (
      {
        id,
        stock_code: stockCode,
        catalogue: catCode,
        part_code: partCode,
        brand_and_description_short: itemName,
        brand,
        primary_root_category: category,
        isSimilarStock,
      },
      i,
    ) => ({
      item_id: stockCode,
      part_code: catCode || partCode,
      item_name: itemName,
      currency: 'GBP',
      // discount: 0.0,
      index: products.length > 0 ? i + 1 : productIndex,
      item_brand: brand,
      item_category: category,
      // item_category2: "Enclosures",
      // item_category3: "PVC Enclosures",
      item_list_id: itemListId,
      item_list_name: itemListName,
      // affiliation: "Online",
      // item_variant: "Same Day Range",
      // delivery_stock: 'In Stock',
      // selected_store: 'Durham',
      // store_stock: 'Out of Stock',
      price: prices[id] ? prices[id].price : prices,
      quantity: 1,
      id_variant: id,
      productType: isSimilarStock ? 'SimilarStock' : '',
    }),
  );
};
